import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { replace } from 'connected-react-router'

import { updateFeatureStatus } from 'actions/feature/features'
import {
  getFeatureMetadata,
  getFeatureIsValid,
} from 'selectors/feature/featureMetadata'
import { getIsHistoryRoute } from 'selectors/router'

import FeatureStatus from './FeatureStatus'

const mapStateToProps = (state, ownProps) => {
  const featureMetadata = getFeatureMetadata(state)
  const isHistoryRoute = getIsHistoryRoute(state)

  const { moduleName, partNumber, status, id: featureId } = featureMetadata

  // Get revision directly from state to avoid affecting other consumers of featureMetadata
  // Default to '-' if featureId is not available or revision is not set
  const revision = featureId
    ? state.getIn(
        ['feature', 'currentFeature', 'feature', featureId, 'revision'],
        '-'
      )
    : '-'

  return {
    ...ownProps,
    moduleName,
    partNumber,
    revision,
    status,
    featureIsValid: getFeatureIsValid(state),
    isHistoryRoute,
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      setStatus: updateFeatureStatus,
      replaceRoute: (locationObj) => replace(locationObj),
    },
    dispatch
  ),
})

const FeatureStatusContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FeatureStatus)

export default FeatureStatusContainer
